import React, { useEffect, useState } from 'react'
import { ATLTextInput, ATLTextInputProps, KeyboardTypeEnum } from '@appsimples/atlantica-react-native'
import { FormInputProps, useFormInput } from 'react-simple-hooks-forms/dist'
import { cpfMask } from '../../utils/masks'
import { atlTheme } from '../../atlTheme'
import { platformConfig } from '../../constants/platform'
import { quarterOfWindowWidth } from '../../constants/quarterOfWindowWidth'
import { useController } from 'react-hook-form'

export type ATLTextInputDocumentMaskFieldProps = FormInputProps &
  ATLTextInputProps & {
    formVersion?: '1' | '2' // The version of the form library to use.
  }

export const ATLTextInputDocumentMaskField: React.FunctionComponent<ATLTextInputDocumentMaskFieldProps> = (
  props,
  children
) => {
  let value, setValue, error
  if (props.formVersion === '2') {
    const form = useController({ name: props.name })
    value = form.field.value || undefined
    setValue = form.field.onChange
    error = form.fieldState.error?.message || form.fieldState.error?.[0]
  } else {
    const { value: valueLegacy, setValue: setValueLegacy, error: errorLegacy } = useFormInput(props)
    value = valueLegacy
    setValue = setValueLegacy
    error = errorLegacy
  }
  const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined)

  useEffect(() => {
    if (error && Array.isArray(error)) {
      setErrorMessage(error[0])
    } else {
      setErrorMessage(error)
    }
  }, [error])

  const onChange = (text: string) => {
    setValue(cpfMask(text))
  }

  return (
    <ATLTextInput
      value={value}
      horizontalMargin={platformConfig.isWeb() ? quarterOfWindowWidth : atlTheme.SpacingDistribute}
      onChange={text => onChange(text)}
      errorText={errorMessage}
      keyboardType={platformConfig.isWeb() ? undefined : KeyboardTypeEnum.numeric}
      textInputBaseProps={{ focusColor: atlTheme.ColorMediumContrast, leftIconColor: atlTheme.ColorBrand2Default }}
      {...props}
      children={children}
    />
  )
}

ATLTextInputDocumentMaskField.defaultProps = {
  formVersion: '1',
}
